import { LogoutOutlined } from '@ant-design/icons';
import styles from 'layouts/main/LayoutMain.module.scss';
import { useTranslation } from 'react-i18next';
import { useUserStore } from 'store/user';
import type { TComponent } from 'utils/types/component';

export const LogoutButton: TComponent = () => {
    const logout = useUserStore('logout');

    const { t } = useTranslation();

    return (
        <div onClick={logout} className={styles.menuItemButtonContainer}>
            <LogoutOutlined className={styles.logoutIcon} />
            <span className={styles.logoutText}>
                {t('common.buttons.logout')}
            </span>
        </div>
    );
};
